<template>
  <div class="dish-showcase">
    <!-- 侧边分类菜单 -->
    <div class="sidebar">
      <div class="sidebar-title">菜品分类</div>
      <ul class="category-list">
        <li><router-link to="/cp/mycp1" exact-active-class="active">荤菜</router-link></li>
        <li><router-link to="/cp/mycp5" exact-active-class="active">半荤菜</router-link></li>
        <li><router-link to="/cp/mycp2" exact-active-class="active">素菜</router-link></li>
        <li><router-link to="/cp/mycp3" exact-active-class="active">主食甜点</router-link></li>
        <li><router-link to="/cp/mycp4" exact-active-class="active">精品小吃</router-link></li>
      </ul>
    </div>

    <!-- 菜品网格区域 -->
    <div class="dish-grid">
      <div class="dish-card" v-for="(dish, idx) in dishList" :key="idx">
        <el-image
          class="dish-img"
          :src="dish.thumb"
          :preview-src-list="[dish.preview]"
          fit="cover"
        >
          <div slot="error" class="error-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <div class="dish-info">
          <span class="dish-name">{{ dish.name }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dishList: [
        { name: '山东手工空心面', thumb: require('../../assets/cp/jbc/jpxc/d.png'), preview: require('../../assets/cp/jbc/jpxc/d1.png') },
        { name: '酸汤大刀面', thumb: require('../../assets/cp/jbc/jpxc/02.jpg'), preview: require('../../assets/cp/jbc/jpxc/02-b.jpg') },
        { name: '桂林米粉', thumb: require('../../assets/cp/jbc/jpxc/03.jpg'), preview: require('../../assets/cp/jbc/jpxc/03-b.jpg') },
        { name: '鸡汤面', thumb: require('../../assets/cp/jbc/jpxc/04.jpg'), preview: require('../../assets/cp/jbc/jpxc/04-b.jpg') },
        { name: '襄县焖面', thumb: require('../../assets/cp/jbc/jpxc/05.jpg'), preview: require('../../assets/cp/jbc/jpxc/05-b.jpg') },
        { name: '牛肉拉面', thumb: require('../../assets/cp/jbc/jpxc/06.jpg'), preview: require('../../assets/cp/jbc/jpxc/06-b.jpg') },
        { name: '牛杂面', thumb: require('../../assets/cp/jbc/jpxc/07.jpg'), preview: require('../../assets/cp/jbc/jpxc/07-b.jpg') },
        { name: '排骨米线', thumb: require('../../assets/cp/jbc/jpxc/08.jpg'), preview: require('../../assets/cp/jbc/jpxc/08-b.jpg') },
        { name: '手工面', thumb: require('../../assets/cp/jbc/jpxc/09.jpg'), preview: require('../../assets/cp/jbc/jpxc/09-b.jpg') },
        { name: '牛肉汤', thumb: require('../../assets/cp/jbc/jpxc/10.jpg'), preview: require('../../assets/cp/jbc/jpxc/10-b.jpg') },
        { name: '合记烩面', thumb: require('../../assets/cp/jbc/jpxc/11.jpg'), preview: require('../../assets/cp/jbc/jpxc/11-b.jpg') },
        { name: '羊杂汤', thumb: require('../../assets/cp/jbc/jpxc/12.jpg'), preview: require('../../assets/cp/jbc/jpxc/12-b.jpg') },
        { name: '麻辣烫', thumb: require('../../assets/cp/jbc/jpxc/13.jpg'), preview: require('../../assets/cp/jbc/jpxc/13-b.jpg') },
        { name: '牛肉丸子汤', thumb: require('../../assets/cp/jbc/jpxc/14.jpg'), preview: require('../../assets/cp/jbc/jpxc/14-b.jpg') },
        { name: '特色卤面', thumb: require('../../assets/cp/jbc/jpxc/15.jpg'), preview: require('../../assets/cp/jbc/jpxc/15-b.jpg') },
        { name: '肉丝炝锅面', thumb: require('../../assets/cp/jbc/jpxc/16.jpg'), preview: require('../../assets/cp/jbc/jpxc/16-b.jpg') },
        { name: '热干面', thumb: require('../../assets/cp/jbc/jpxc/17.jpg'), preview: require('../../assets/cp/jbc/jpxc/17-b.jpg') },
        { name: '土鸡面', thumb: require('../../assets/cp/jbc/jpxc/18.jpg'), preview: require('../../assets/cp/jbc/jpxc/18-b.jpg') },
        { name: '羊肉泡馍', thumb: require('../../assets/cp/jbc/jpxc/19.jpg'), preview: require('../../assets/cp/jbc/jpxc/19-b.jpg') },
        { name: '鸡汤混沌', thumb: require('../../assets/cp/jbc/jpxc/20.jpg'), preview: require('../../assets/cp/jbc/jpxc/20-b.jpg') },
        { name: '方城烩面', thumb: require('../../assets/cp/jbc/jpxc/21.jpg'), preview: require('../../assets/cp/jbc/jpxc/21-b.jpg') },
        { name: '豆腐菜', thumb: require('../../assets/cp/jbc/jpxc/22.jpg'), preview: require('../../assets/cp/jbc/jpxc/22-b.jpg') },
        { name: '番茄牛肉面', thumb: require('../../assets/cp/jbc/jpxc/23.jpg'), preview: require('../../assets/cp/jbc/jpxc/23-b.jpg') },
        { name: '大排面', thumb: require('../../assets/cp/jbc/jpxc/24.jpg'), preview: require('../../assets/cp/jbc/jpxc/24-b.jpg') },
        { name: '葱油拌面', thumb: require('../../assets/cp/jbc/jpxc/01.jpg'), preview: require('../../assets/cp/jbc/jpxc/01-b.jpg') },
        { name: '菌香牛肉拌面', thumb: require('../../assets/cp/jbc/jpxc/b.png'), preview: require('../../assets/cp/jbc/jpxc/b1.png') },
        { name: '鸡丝拌面', thumb: require('../../assets/cp/jbc/jpxc/a.png'), preview: require('../../assets/cp/jbc/jpxc/a1.png') },
        { name: '肉沫拌面', thumb: require('../../assets/cp/jbc/jpxc/c.png'), preview: require('../../assets/cp/jbc/jpxc/c1.png') },
      ]
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.dish-showcase {
  max-width: 80%;
  margin: 30px auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
}

/* 侧边菜单 */
.sidebar {
  width: 220px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  height: fit-content;
}
.sidebar-title {
  background: linear-gradient(135deg, #f97316, #facc15);
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  text-align: center;
  padding: 16px 0;
  letter-spacing: 2px;
}
.category-list {
  list-style: none;
  padding: 12px 0;
}
.category-list li {
  margin: 0;
}
.category-list a {
  display: block;
  padding: 12px 24px;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #4a5568;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}
.category-list a:hover {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  padding-left: 28px;
}
.category-list a.active {
  background: #fef3e2;
  color: #f97316;
  border-left-color: #f97316;
  font-weight: 600;
}

/* 菜品网格 */
.dish-grid {
  flex: 1;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 24px;
}
.dish-card {
  background: #fff;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s, box-shadow 0.25s;
}
.dish-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 28px -12px rgba(0, 0, 0, 0.15);
}
.dish-card:hover .dish-info {
  background: #b03e45;
}
.dish-card:hover .dish-info .dish-name {
  color:#fff;
}
.dish-img {
  width: 100%;
  height: 200px;
  display: block;
  background: #f0f0f0;
}
.dish-img /deep/ img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s;
}
.dish-card:hover .dish-img /deep/ img {
  transform: scale(1.03);
}
.dish-info {
  padding: 14px 16px 18px;
  text-align: center;
  background: #fff;
}
.dish-name {
  font-size: 18px;
  font-weight: 600;
  color: #2d3748;
  letter-spacing: 1px;
}
.error-slot {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  color: #cbd5e0;
}
</style>